import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to New Orleans needed",
      "Ideal for Keesler AFB PCS and deployment orders",
      "Perfect for Beau Rivage and casino industry business travel",
      "Great for cruise passengers departing New Orleans or Mobile",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Biloxi post offices",
      "Good for planned international trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Biloxi area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: New Orleans — ~90 min drive from Biloxi",
      "NPIC appointment required before traveling to New Orleans",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function BiloxiProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Biloxi"
      introText="Biloxi travelers — Keesler AFB service members with PCS orders to Germany or Japan, Beau Rivage executives with business trips to Macau, cruise passengers heading to the Caribbean from New Orleans and Mobile, and families across the Mississippi Gulf Coast — have several options for getting a passport fast. Here is how they compare, and why most Biloxi residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to New Orleans."
      options={options}
      emergencyDescription="Biloxi does not have its own regional passport agency. The closest is New Orleans (~90 min west via I-10). Keesler AFB personnel with deployment orders face a 3+ hour round-trip plus all-day processing. I-10 construction through Slidell and the Twin Span Bridge adds unpredictable delays. During hurricane season, contraflow evacuation on I-10 makes the route impassable for hours."
      disclaimerText="*Processing speed depends on eligibility and documentation. Biloxi does not have a regional passport agency — the closest is New Orleans. Not all applicants qualify for Regional Agency Processing."
    />
  );
}